
import { defineComponent, ref, getCurrentInstance } from 'vue';
import logisticsInfoDialog from './components/logistics-info-dialog/index.vue';
import { getLogisticsList, deleteLogistics } from '@/api/system-config/index';
import { getLabelByVal } from '@/core/utils/index';
import { ILogisticsSelectLogisticsNameRes } from '@/api/system-config/type.d';
import { ElMessageBox } from 'element-plus';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  components: {
    logisticsInfoDialog,
  },
  setup() {
    const globalProperties = getCurrentInstance()?.appContext.config?.globalProperties;
    const has = globalProperties?.$has;
    const permissionConfig = usePermissionConfig();
    // 物流框显示
    const logisticsDialogVisible = ref<boolean>(false);
    // 列表树
    const logisticsList = ref<ILogisticsSelectLogisticsNameRes[]>([]);
    // 搜索
    const handleSearch = async () => {
      try {
        const params = {
        };
        const res = await getLogisticsList(params);
        logisticsList.value = res.data || [];
      } catch (error) {
        console.log(error);
      }
    };
    handleSearch();

    // 列表树显示字段
    const defaultProps = ref(
      {
        children: 'childList',
        label: 'name',
      },
    );

    const rowItem = ref({});
    // 操作项
    const logisticsType = ref<string>('');
    const logisticsModel = (type: string, row?: ILogisticsSelectLogisticsNameRes) => {
      if (['addChild', 'edit'].includes(type)) {
        rowItem.value = { ...row };
      }
      logisticsType.value = type;

      logisticsDialogVisible.value = true;
    };

    // 删除物流项
    const deleteLogisticsItem = async (row: ILogisticsSelectLogisticsNameRes) => {
      try {
        await ElMessageBox.confirm(`确定删除${row.name}？`, '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
        });
        await deleteLogistics(row.logisticsId);
        handleSearch();
      } catch (error) {
        console.log(error);
      }
    };

    // 列表树渲染项
    const renderContent = (h: any, { node, data }: any) => {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>
            {
              has?.(permissionConfig.CREATE) && node.level === 1 ? (
                <el-button
                  size="mini" type="text"
                  onClick={() => logisticsModel('addChild', data) }
                >新增</el-button>
              ) : null
            }

            {has?.(permissionConfig.UPDATE)
              && <el-button size="mini" type="text" onClick={() => logisticsModel('edit', data) }>编辑</el-button>}
            {
              !data?.childList?.length && has?.(permissionConfig.DELETE) ? (
                <el-button size="mini" type="text" onClick={() => deleteLogisticsItem(data) }>删除</el-button>
              ) : null
            }

          </span>
        </span>
      );
    };

    return {
      handleSearch,
      getLabelByVal,
      defaultProps,
      logisticsList,
      logisticsDialogVisible,
      logisticsModel,
      renderContent,
      logisticsType,
      rowItem,
      permissionConfig,
    };
  },
});
